module.exports = __webpack_public_path__ + "img/top-10-list-view.47cb1738.jpg";